import { render } from "./ErrorMessage.vue?vue&type=template&id=6cbc8b97&ts=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3510055582/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__